// ugh: https://github.com/inspect-js/has-bigints/pull/11
Object.assign(window, { global: window });

export {};

export default window;
